import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";

// `npm run dev:emulators`: aponta para os emuladores locais e nunca para o ccb-bh.
const useEmulators = import.meta.env.VITE_FIREBASE_EMULATORS === "true";

const firebaseConfig = {
  apiKey: "AIzaSyCZaXxxQwEzs8dwISDLNsyMeAKN8pW--SU",
  authDomain: "ccb-bh.firebaseapp.com",
  projectId: "ccb-bh",
  storageBucket: "ccb-bh.appspot.com",
  messagingSenderId: "793613497805",
  appId: "1:793613497805:web:937e60588f23836c060084",
  measurementId: "G-B0FEH7S61R",
};

// Login único (contrato claims-acesso v1.1.0, §9): a conta CCB entra pelo portal Acesso CCB e chega
// aqui como custom token (`signInWithCustomToken`); o app não tem login com senha nem Google.
const app = initializeApp(useEmulators ? { ...firebaseConfig, projectId: "demo-ccb-docs" } : firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

if (useEmulators) {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
}
